<template>
  <b-form-group
    label-cols="3"
    style="cursor: grab"
  >
    <template #label>
      <span><font-awesome-icon
        icon="grip-vertical"
        size="sm"
      /> {{ label }}</span>
    </template>
    <div class="d-flex">
      <b-select
        :id="`select-hierarchy-level-${level}`"
        v-model="selected"
        :options="options"
        :state="state && null"
        :data-cy="`select-hierarchy-level-${level}`"
      />
      <b-button
        v-if="useNLevels"
        variant="outline-danger"
        :style="{ visibility: level === 1 ? 'hidden' : '' }"
        class="ml-3"
        @click="upload.deleteLevel(level)"
      >
        <font-awesome-icon icon="trash-alt" />
      </b-button>
      <div
        class="flex-grow-1 ml-3 d-flex align-items-center"
        :title="bubblesExplanation(level)"
      >
        <b-checkbox
          v-if="useNLevels"
          v-model="showBubbles"
          :disabled="showBubblesDisabled(level)"
          style="white-space: nowrap;"
        >
          Show as bubbles
        </b-checkbox>
      </div>
    </div>
    <b-form-invalid-feedback :state="state && null">
      {{ invalidMessage }}
    </b-form-invalid-feedback>
  </b-form-group>
</template>

<script lang="ts">
import Component from 'vue-class-component'
import BubblesLevelsMixin from '@/mixins/BubblesLevelsMixin'
import { useUploadStore } from '@/store/admin/upload'

// eslint-disable-next-line no-use-before-define
@Component<SelectHierarchy>({
  props: {
    level: {
      type: Number,
      required: true,
    },
    v: {
      type: Object,
      required: true,
    },
  },
})
export default class SelectHierarchy extends BubblesLevelsMixin {
  upload = useUploadStore()
  level!: number
  v!: any

  get useNLevels () {
    return this.$typedStore.features.useNLevels
  }

  get label () {
    return `Level ${this.level} column`
  }

  get headers () {
    return this.upload.headers
  }

  get state () {
    return this.v.$dirty ? !this.v.$error : null
  }

  get levelsHelper () {
    return this.upload.levelsHelper
  }

  get invalidMessage () {
    const validation = this.v.validations
    if (!validation.required) {
      return 'This field is required'
    }
    if (!validation.noBlanks) {
      return 'This field has some rows with blank values. Please choose another field or change your CSV and re-upload.'
    }
    if (!validation.valid) {
      return 'This field has data that contains "/". Please choose another field or change your CSV and re-upload.'
    }
    if (!validation.unique) {
      return 'This field does not contain unique values. Please choose another field or change your CSV and re-upload.'
    }
    return null
  }

  get options () {
    const headers = this.headers.map((item) => {
      return {
        text: item,
        value: item,
      }
    })
    return [{ text: '(Select CSV column)', value: null }, ...headers]
  }

  get selected () {
    return this.levelsHelper.columnForLevel(this.level)
  }

  set selected (newValue) {
    this.upload.updateLevel({
      column: newValue,
      level: this.level,
    })
  }

  get showBubbles () {
    return this.levelsHelper.fieldForLevel(this.level)?.showBubbles || false
  }

  set showBubbles (newValue: boolean) {
    this.upload.updateFieldProperty({
      column: this.selected,
      partialValue: {
        showBubbles: newValue,
      },
    })
  }
}

</script>
